module.exports = __webpack_public_path__ + "static/media/llorando.c7319dbc.jpg";